import {fetchPersonnelList} from '@/entities/personnel/api';
import type {PagedPersonnel} from '@/entities/personnel/types';

/**
 * The whole roster in one page — the shape two features need and must agree on.
 *
 * The bulk sheet loads it to choose people from; the personnel form loads it to
 * work out the next free employee number. Both read it under the SAME query key,
 * so whichever opens second pays nothing. That only holds while the page size is
 * also the same: two callers asking for `['personnel-list', id, 'bulk']` with
 * different `per_page` would serve each other a truncated list and neither would
 * know. Hence one place, one constant, one query.
 */

/** How many people a roster loads. Above this, use the desktop app. */
export const ROSTER_LIMIT = 500;

export function rosterQuery(companyId: string) {
  return {
    queryKey: ['personnel-list', companyId, 'bulk'] as const,
    queryFn: (): Promise<PagedPersonnel> =>
      fetchPersonnelList(companyId, {perPage: ROSTER_LIMIT, page: 1}),
  };
}
